import headerAnalytics from 'header.analytics';
import '../shared/sv-hover-intent';

const shoppingLinks = {};
const config = {
  shoppingLinkSelector: '.ShoppingLinks__link',
  linkOpenClass: 'ShoppingLinks__link--open',
  linkClosingClass: 'ShoppingLinks__link--closing',
  closingTimeout: 300
};

shoppingLinks.triggerHoverIntent = function triggerHoverIntent (elem) {
  document.dispatchEvent(new CustomEvent('hoverintent', { detail: { target: elem } }
  ));
};

shoppingLinks.attachShoppingLinkEvents = function attachShoppingLinkEvents (element) {
  let timeout;

  element.addEventListener('mouseleave', function shoppingLinkMouseLeave () {
    element.classList.remove(config.linkOpenClass);
    element.classList.add(config.linkClosingClass);

    timeout = setTimeout(function shoppingLinkTimeout () {
      element.classList.remove(config.linkClosingClass);
      element.classList.remove(config.linkOpenClass);
    }, config.closingTimeout);
  });

  element.addEventListener('mouseenter', function shoppingLinkMouseEnter () {
    element.classList.add(config.linkOpenClass);
    element.classList.remove(config.linkClosingClass);

    if (timeout) {
      clearTimeout(timeout);
    }
  });
};

shoppingLinks.logInteraction = function logInteraction (elem) {
  let element = elem.closest('a');
  let elementText = element.textContent.toLowerCase();
  if (!element.classList.contains('js__flyout--open')) {
    return headerAnalytics.logEvent('header click', ['header', 'shopping links', elementText].join('>'));
  }
};

shoppingLinks.init = function init () {
  let allShoppingLinksArray = Array.from(document.querySelectorAll(config.shoppingLinkSelector));
  allShoppingLinksArray?.forEach(element => {

    element.addEventListener('click', () => shoppingLinks.logInteraction(element));
    element.addEventListener('touchend', () => shoppingLinks.logInteraction(element));

    // This should be converted to simple hover state - no need for JS any more
    shoppingLinks.attachShoppingLinkEvents(element);
  });
  
  new SV.HoverIntent(document.querySelectorAll(config.shoppingLinkSelector), {
    onEnter: (targetItem) => {
      shoppingLinks.triggerHoverIntent(targetItem);
    },
    onExit: () => { }
  });
};

shoppingLinks.getPrivateMethods = function getPrivateMethods () {
  return shoppingLinks;
};

export default shoppingLinks;